<template>
    <div style="background-color: #f5f5f5">
        <component :is="storeDesign"></component>
    </div>
</template>

<script>
import Webstore1 from './Webstore1.vue';
import Webstore2 from './Webstore2.vue';
import StoreUnderMaintenance from './StoreUnderMaintenance.vue';
import appConstants from '../utils/appConstants'
export default {
    data() {
        return {
            activeStates: [appConstants.BILLING_ACCOUNT.STATUS.ACTIVE, appConstants.BILLING_ACCOUNT.STATUS.CREATED]
        }
    },
    computed: {
        storeDesign() {
            console.log(`status: ${this.activeStates.includes(this.$store.getters?.vendor?.accountStatus)} \t ${this.$store.getters?.vendor?.accountStatus}`);
            
            if(!this.activeStates.includes(this.$store.getters?.vendor?.accountStatus)){
                return StoreUnderMaintenance
            }
            if (this.$store.getters?.vendor?.storeUI == this.newStoreUI)
                return Webstore2
            else
                return Webstore1
        }
    },
    mounted () {
        if(process.env.NODE_ENV === 'production'){
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "spx6g6iwql");
        }
    },
}
</script>
<style scoped></style>
